export const modalInstructions = ()=>{
    const closeInstructions = document.querySelector('.instrucciones__container .btn'),
        boxInstructions = document.querySelector('#contentInstrucciones')

    closeInstructions && closeInstructions.addEventListener('click', (evt) => {
        evt.preventDefault();
        boxInstructions.classList.add('hide')
    })
}
export const regionsPopup = ($region)=>{
 //valle, cauca, choco, narino

//  alert($region)
    console.log('version1')
    if($region == 'valle'){
        location.href = "/region/?zona=valle-del-cauca"
    }
    if($region == 'cauca'){
        location.href = "/region/?zona=cauca"
    }
    if($region == 'choco'){
        location.href = "/region/?zona=choco"
    }
    if($region == 'narino'){
        location.href = "/region/?zona=narino"
    }

}

window.regionsPopup = regionsPopup;